import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose, constants } from 'common/helpers'
import { connect } from 'redaction'
import actions from 'redux/actions'

import Button from 'components/_new/Button/Button'
import PickProducts from 'components/_new/PickProducts/PickProducts'

import Modal from './Modal/Modal'

import s from './PickProductsModal.scss'
import messages from './messages'


class PickProductsModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    data: PropTypes.shape({
      onRemove: PropTypes.func.isRequired,
      onSave: PropTypes.func.isRequired,
    }),
  }

  static defaultProps = {
    name: constants.modals.PickProducts,
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  handleContinue = () => {
    const { data: { onSave } } = this.props

    this.close()
    onSave()
  }

  handleRemove = (id) => {
    const { selectedProductsCount, data: { onRemove } } = this.props

    if (selectedProductsCount === 1) {
      this.close()
    }

    onRemove({ id, isSelected: true })
  }

  render() {
    const { name, selectedProductsCount } = this.props

    return (
      <Modal
        name={name}
        className={s.pickProductsModal}
        title={{ ...messages.title, values: { selectedProductsCount } }}
        subTitle={messages.subTitle}
        onClose={this.close}
      >
        <div>
          <PickProducts onRemove={this.handleRemove} />
          <div className={s.continueButtonContainer}>
            <Button
              className={s.continueButton}
              title={messages.buttonTitle}
              color="brand"
              fullWidth
              size="md"
              rightIcon="rightArrowSmall"
              onClick={this.handleContinue}
            />
          </div>
        </div>
      </Modal>
    )
  }
}


export default compose(
  connect({
    selectedProductsCount: (state) => {
      const { view: { pickPage: { selectedItems } } } = state

      return selectedItems.length
    },
  })
)(PickProductsModal)
